import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TheCage} from "../TheCage";
import {gsap} from "gsap";
import {TheCageSound} from "../sound/TheCageSound";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheCageFreeSpinBetPresentation implements FlowStatePresentation {
    private stepIndex:number = 0;

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        const tl: gsap.core.Timeline = gsap.timeline();

        // if we just entered the freespins the reels will be covered by empty (BLANK) symbols,
        // if this is the case we do not want to play the reels out sound since there are no symbols falling out
        if (TheCage.freeSpinReelView.avalancheMatrixModel.getAllSymbolsWithName("BLANK").filter((sym) => sym.name == "BLANK").length != 24) {
            tl.add(() => {
                TheCage.soundPlayer.playSound(TheCageSound.REELS_OUT);
            });
        }
        tl.add(() => {
            TheCage.freeSpinReelView.avalancheMatrixModel.dropOut();
        });
        tl.add(() => {
            flowStateController.finish()
        }, "<0.3");
    }
}